import React, { useEffect, useState } from 'react';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogContentText,
    DialogActions,
    Button,
    Skeleton,
} from '@mui/material';
import { styles } from './styles';
import Logo from './ANSR-Logo.png';
import { useNavigate } from 'react-router-dom';
import { parseUrl, generateClientUrl } from '../../utils/urlParser';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { setCompanyReferer } from '../../utils/cookieUtils';
import { useGetAllCompaniesMutation } from '../../api/company';
import { getSidebarItems, getSideBarMenuRoutes } from '../../components/layout/SideBarMenuRoutes';

const CompanyItem = (props) => {
    const [openDialog, setOpenDialog] = useState(false);
    const { data } = props;

    const handleConfirm = async () => {
        setOpenDialog(false);
        setCompanyReferer(data.slug);

        const urlInfo = parseUrl();
        const { environment } = urlInfo;

        const targetUrl = generateClientUrl(environment, data.slug, '/');
        window.location.href = targetUrl;
    };

    return (
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Card
                variant="outlined"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: 1,
                    margin: 1,
                    cursor: 'pointer',
                }}
                onClick={() => setOpenDialog(true)}
            >
                <Avatar
                    src={Logo}
                    alt={data.name}
                    sx={{
                        width: 40,
                        height: 40,
                        marginRight: 2,
                        background: '#ed7342',
                        color: '#ffffff',
                    }}
                />
                <CardContent sx={{ padding: '12px 0 !important' }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {data.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {data.role_name}
                    </Typography>
                </CardContent>
            </Card>
            <Dialog open={openDialog}>
                <DialogContent sx={{ minWidth: '400px', maxWidth: '500px' }}>
                    <Box sx={styles.tableMenuDialog}>
                        <DialogTitle textAlign={'center'}>Confirm</DialogTitle>
                        <DialogContentText>{`Do you want to switch to company ${data.name}?`}</DialogContentText>
                    </Box>
                    <DialogActions>
                        <Button size="medium" variant="text" onClick={() => setOpenDialog(false)}>
                            No
                        </Button>
                        <Button size="medium" variant="contained" onClick={handleConfirm}>
                            Yes
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </Grid>
    );
};

const CompanySelect = () => {
    const [companyList, setCompanyList] = useState([]);
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.session);
    const { enqueueSnackbar } = useSnackbar();

    const [getAllCompanies, { isLoading, data: companiesData, error }] = useGetAllCompaniesMutation();

    useEffect(() => {
        getAllCompanies();
    }, []);

    useEffect(() => {
        if (error) {
            enqueueSnackbar(error?.message || 'Something went wrong!', { variant: 'error' });
            return navigate('/login');
        }
        if (!companiesData) return;
        const urlInfo = parseUrl();
        const { environment, isDefaultUrl } = urlInfo;

        if (isDefaultUrl) {
            if (companiesData?.companies?.length === 1) {
                const companySlug = companiesData?.companies[0]?.slug;
                setCompanyReferer(companySlug);

                const targetUrl = generateClientUrl(environment, companySlug, '/');
                window.location.href = targetUrl;
            } else setCompanyList(companiesData?.companies);
        } else {
            const sideMarItems = getSidebarItems(
                user?.authorities,
                { isClientHqEnabled: user?.isClientHqEnabled },
                getSideBarMenuRoutes({ isClientHqEnabled: user?.isClientHqEnabled }),
            );

            navigate(sideMarItems[0]?.href || '/account');
        }
    }, [companiesData, user, error]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Company</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card sx={{ padding: '30px' }}>
                    <Box>
                        <Typography variant="subtitle2">{"Kindly choose the company you'd like to access."}</Typography>
                    </Box>
                    <Box sx={{ paddingY: 4 }}>
                        {isLoading ? (
                            <Box>
                                <Skeleton height={42} />
                                <Skeleton />
                                <Skeleton />
                            </Box>
                        ) : (
                            <Grid container spacing={2}>
                                {companyList.map((company) => (
                                    <CompanyItem key={company.id} data={company} />
                                ))}
                            </Grid>
                        )}
                    </Box>
                </Card>
            </Box>
        </Box>
    );
};

export default CompanySelect;
